module.exports = __webpack_public_path__ + "img/logout.119f1494.svg";